// -*- Mode: rjsx -*-
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';


import { fetchHistory } from '..';
import LinearProgress from '@mui/material/LinearProgress';


import Header  from './Header.jsx';
import Item from './Item.jsx';

function Loading(props) {
    const loading = useSelector(state => state.history.loading);
    let fetching = loading === 'loading';

    if(fetching)
        return <div style={{margin: 16 }}><LinearProgress /></div>;
    else
        return null;
    
}

function History(props) {
    const key = props.requestKey;
    const dispatch = useDispatch();

    const request = props.request;
    const history = useSelector(state => state.history.byRequest[key] || []);

    useEffect(() => {
        let cursor = '-';
        while(cursor != '') {
            if(cursor === '-') cursor = '';
            console.log("fetching with cursor: %o", cursor);

            dispatch(fetchHistory({ key: key, cursor: cursor }));
        }

    }, [dispatch]);


    // let's show a couple
    if(!history.length) {
        let fake = { type: "fake" };
        return (<>
                  <Item opacity={0.7} note={fake} />
                  <Item opacity={0.5}  note={fake} />
                </>);
    }


    return (
        <>
          { history.map((m) => <Item note={m} />) }
          <Loading />
        </>
    );
}

export { History };
